import HSM from '@/services/hsm-api.service'

export default (function () {
  let instance = null

  function createInstance () {
    const authToken = sessionStorage.getItem('authToken')
    const object = new HSM({
      baseUrl: process.env.VUE_APP_HSM_API_BASE,
      authToken
    })
    return object
  }

  return {
    getInstance: function (renew = false) {
      if (!instance || renew) instance = createInstance()
      return instance
    }
  }
})()
